import { getTimezoneOffset } from 'date-fns-tz';

export default function getCurrentDateInGivenTimezone(timeZone: string): Date {
    const timeZoneOffset = getTimezoneOffset(timeZone);
    return new Date(new Date().getTime() + timeZoneOffset);
}
